import { Container } from 'inversify'
import { rootContainer } from '~/container'
import { interpret } from '~/node_modules/xstate'
import { FaqRepositoryFetch } from './FaqRepositoryFetch'
import { returnFaqMachine } from './machine'
import { FaqRepository } from './types'

export const faqContainer = new Container()

faqContainer.parent = rootContainer
faqContainer.bind(FaqRepository).to(FaqRepositoryFetch)

export function getFaqMachine(langCode: string) {
  return interpret(
    returnFaqMachine().withConfig({
      services: {
        fetchAll: () => faqContainer.get(FaqRepository).getAll(langCode),
        fetchStandalone: (_, { slug }: any) =>
          faqContainer.get(FaqRepository).getStandaloneBySlug(langCode, slug),
      },
    }),
  )
}
